var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoCooperation = function SvgHospitalinfoCooperation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M16 25a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M13 28c0-1.66 1.34-3 3-3s3 1.34 3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M7 25a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M4 28c0-1.66 1.34-3 3-3s3 1.34 3 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M25 25a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M22 28c0-1.66 1.34-3 3-3s3 1.34 3 3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M23 15.63h-6.63V11h-.75v4.62H9c-1.31 0-2.37 1.06-2.37 2.37v1h.75v-1c0-.89.73-1.62 1.62-1.62h6.63V19h.75v-2.62H23c.89 0 1.62.73 1.62 1.62v1h.75v-1A2.36 2.36 0 0 0 23 15.63"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M16 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 7.5h-1.5V6h-1v1.5H14v1h1.5V10h1V8.5H18z"
  })));
};
export default SvgHospitalinfoCooperation;